export default {
    taggingItem: {},

    isTaggingActive: false,
    isLoading: false,

    caseId: null,
    clientId: null,
    device: null,
    clientInfo: null,
};